











































































































































































































































import {
    EventBus,
    TypeEventBus,
    getUniqueId,
    addItemsToListIfAreNotAdded,
    removeItemsFromList,
    itemsPerPageOptionsTable,
    isNullOrEmpty,
    formRules
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import { MultipleSelect, MsgBox } from '../../core/components';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Input from '../../core/components/Input.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import TableArrows from '../../core/components/TableArrows.vue';
import CustomSwitch from '../../core/components/CustomSwitch.vue';
import multiselect from 'vue-multiselect';
import CreateUnityTypeAndVar from './CreateUnityTypeAndVar.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import Sortable from 'sortablejs';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { NormsServices } from '../../norms/api/NormsServices';
import { VariableReport, VariableReportList } from '../models/VariableReport';
import vColumnsResizable from '../../../plugins/vue-columns-resizable'

@Component({
    directives: {
        'v-columns-resizable': vColumnsResizable,
    },
    components: { 
        CreateUnityTypeAndVar, 
        MultipleSelect, 
        MsgBox, 
        TableArrows,
        SimpleTable, 
        multiselect,
        DeleteConfirmation,
        CustomSwitch,
        InfoIcon,
        Input
    }
})
export default class ModalVariableReport extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({default: {}}) variableReportToEdit: VariableReportList;
    @Prop() variablesDefinitionFromSelectedVariableClassification: any;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    

    selectVehicle: any = null;
    createModalTitle: string = 'Crear Variable Report';
    editModalTitle: string = 'Modificar Variable Report:';
    modalTitle: string = this.createModalTitle;
    vehicleOptions = ['Todas', 'Seleccionadas'];

    availableSelectedVariables: any[] = [];
    searchVariables: string = '';
    selectedVariables: any = [];
    searchIntoSelectedVariables: string = '';

    variableDefinitionList: any[] = [];

    description: string = '';
    privateDescription: string = '';

    searchVar: string = '';
    searchVarInGroup: string = '';

    availableVariablesSelected: any[] = [];

    searchavailableVariables: string = '';
    availableVehicles: Array<object> = [];
    loadingAvailableVariables: boolean = false;
    visibleMobile: boolean = false;
    alarmable: boolean = false;

    selectedUnit: any = {};

    processingRequest: boolean = false;
    valid: boolean = false;

    visibleModalCreateUTV: boolean = false;
    editingUTV: boolean = false;
    patchDataUTV: any = {};
    actionModalUTV: string = '';
    unitySelected: any | null = null;

    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    decimals: number = 0;
    decimalsRules: any = formRules.numericPositive

    get getAvailableVariablesSelected() {
        return this.availableVariablesSelected.length > 0;
    }

    get getSelectedVariables() {
        return this.availableSelectedVariables.length > 0;
    }

    updateDecimals(value) {
        this.decimals = value;
    }

    confirmAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.patchVariableReport(this.getData());
        } else {
            this.confirmationDelete = false;
        }
    }

    moveVariableToTheRight() {
        let self = this;
        //agrego el parametro calculado si no fue agregado a los calculados seleccionados
        const copyOfVariablesSelected = JSON.parse(JSON.stringify(this.selectedVariables));
        for (let i = 0; i < this.availableVariablesSelected.length; i++) {
            let variable = this.availableVariablesSelected[i];
            copyOfVariablesSelected.push(variable);
        }
        this.removeSelectedVariableFromMainList(this.availableVariablesSelected);
        this.selectedVariables = copyOfVariablesSelected;
        this.availableVariablesSelected = [];
    }

    removeSelectedVariableFromMainList(itemsToExclude) {
        this.variableDefinitionList = removeItemsFromList(this.variableDefinitionList, itemsToExclude, 'id');
    }

    moveVariableToTheLeft() {
        const copyOfVariables = JSON.parse(JSON.stringify(this.variableDefinitionList));

        for (let i = 0; i < this.availableSelectedVariables.length; i++) {
            let itemToExclude = this.availableSelectedVariables[i];
            let index = this.selectedVariables.indexOf(itemToExclude);
            this.selectedVariables.splice(index, 1);
            copyOfVariables.push(itemToExclude);
        }
        this.variableDefinitionList = copyOfVariables;
        this.availableSelectedVariables = [];
    }

    get shouldCreateAndDeleteUnit(): boolean {
        return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.CREATE) ||
            this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.EDIT_AND_DELETE)
        );
    }

    get tableSelectedVariables(): HTMLFormElement {
        return this.$refs.tableSelVariables as HTMLFormElement;
    }

    initCalcVariablesDragDrop() {
        let vm = this;
        let table = this.tableSelectedVariables.$el.querySelector('tbody');
        const _self = this;
        Sortable.create(table, {
            handle: '.handle', // Use handle so user can select text
            onEnd({ newIndex, oldIndex }) {
                const rowSelected = _self.selectedVariables.splice(oldIndex, 1)[0]; // Get the selected row and remove it
                _self.selectedVariables.splice(newIndex, 0, rowSelected); // Move it to the new index
            }
        });
    }

    async getAvailableVariables() {
        this.loadingAvailableVariables = true;
        this.variableDefinitionList = await NormsServices.getVariableClassificationReport();
        if (this.isPatch) this.removeSelectedVariableFromMainList(this.selectedVariables);
        this.loadingAvailableVariables = false;
    }

    customItemClass(item) {
        return 'truncate-row';
    }

    get getVariablesDefinition() {
        return this.variableDefinitionList;
    }

    get headersAvailableVariables() {
        return [
            {
                text: 'Variables',
                value: 'description',
                sortable: true
            }
        ];
    }

    get headersAvailableVariablesWithArrow() {
        return [
            {
                text: '',
                align: 'left',
                sortable: false,
                value: 'handle',
                class: 'short-column'
            },
            {
                text: 'Variables',
                value: 'description',
                sortable: true
            }
        ];
    }

    nameRules: any = [
        v => !!v || 'Debe ingresar la descripción',
        v => (v && v.length >= 1) || 'Debe ingresar la descripción'
    ];

    get isPatch(){
        if(this.variableReportToEdit !== null){
            return true
        }
        return false
    }

    mounted() {
        this.getAvailableVariables();
        this.$nextTick(() => {
            this.initCalcVariablesDragDrop();
            this.loadPatchData();
        });
    }

    loadPatchData() {
        if (this.isPatch) {
            this.setModalTitle(this.editModalTitle + ' <b>' + this.variableReportToEdit.description + '</b>');
            this.setVariableDescription(this.variableReportToEdit.description);
            this.setPrivateDescription();
            this.setClasifications(this.variableReportToEdit);
            this.updateDecimals(this.variableReportToEdit['decimal_digit_format']);
            this.visibleMobile = this.variableReportToEdit['show_mobile'];
        } else {
            this.setModalTitle(this.createModalTitle);
        }
    }

    setPrivateDescription(){
      this.privateDescription = this.variableReportToEdit.private_description
    }

    setClasifications(variableReport: VariableReportList){
        this.selectedVariables = variableReport['variable_classifications'];
        this.removeSelectedVariableFromMainList(this.availableVariablesSelected);
    }

    setModalTitle(value: string){
        this.modalTitle = value;
    }

    submitVariable() {
        let data = this.getData();
        if (!this.isPatch) {
            this.createVariableReport(data);
        } else {
            this.showConfirmMessage();
        }
    }

    showConfirmMessage(){
        this.deleteModalTitle = 'Confirmar acción';
        this.deleteBody = 'Esta acción puede impactar en las configuraciones de alarmas asociadas a ésta variable<br> <b>¿Está seguro que desea continuar?<b>';
        this.confirmationDelete = true;
    }

    patchVariableReport(data){
        this.pendingLoadingDialog('Modificando Variable Report');
        let idToPatch = this.variableReportToEdit['id'];
        NormsServices.patchVariableReport(
            data,
            idToPatch
        ).then((res) => {
            this.handleSuccessAction(res.data);
            this.updateList();
        }).catch((res) => {
            this.handleErrorAction(res, 'No se pudo modificar la variable report');
        })
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }

    createVariableReport(data){
        this.pendingLoadingDialog('Creando Variable Report');
        NormsServices.postVariableReport(
            data
        ).then((res) => {
            this.handleSuccessAction(res);
            this.addNewVariableReport(res['variablereport']);
        }).catch((res) => {
            this.handleErrorAction(res, 'No se pudo crear la variable report');
        })
    }

    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    setVariableDescription(value){
        this.description = value;
    }

    get canSaveVariable() {
        if(this.description === '' || this.description == null){
            return false
        }
        if(isNullOrEmpty(this.decimals) || this.decimals < 0){
            return false
        }
        if(this.isPatch && this.selectedVariables.length == 0){
            return false
        }
        return true
    }

    getData(){
        let data = {
            description: this.description.trim(),
            private_description: this.privateDescription,
            show_mobile: this.visibleMobile,
            decimal_digit_format: isNullOrEmpty(this.decimals) ? 0 : Number(this.decimals)
        }
        if(this.privateDescription !== ''){
            data['private_description'] = this.privateDescription.trim()
        }
        if(this.isPatch){
            data['variable_classification_list'] = this.selectedVariables.map(function(item){
                return item['id']
            })
        }
        return data
    }

    @Emit()
    closeModal() {}

    @Emit()
    addNewVariableReport(variableReport: VariableReport) {}

    @Emit()
    updateList() {}
}
